import * as api from './api'
import { getLocalData, setLocalData } from '@/helper/localStorage'
import { PRODUCT } from '@/constants/localStorage'
import { THREE_HOUR } from '@/constants/time'

import { checkTtlDate } from '@/helper'

export default {
  async loadData ({ commit }, { force = false } = {}) {
    const productsLocal = getLocalData(PRODUCT)
    const isNeedUpdate = checkTtlDate({
      timeUpdate: (productsLocal?.updateDate || 0),
      ttlTime: THREE_HOUR
    })

    if (!force && productsLocal && !isNeedUpdate) {
      commit('setData', productsLocal.data)

      return { data: productsLocal.data }
    }

    const { data } = await api.loadData() || {}

    if (data?.code === 200) {
      setLocalData(PRODUCT, {
        updateDate: Date.now(),
        data: data.data
      })

      commit('setData', data.data)

      return { data: data.data }
    }

    return { error: data.data }
  },
  async getDataByCategoryId (_, payload) {
    const { data } = await api.getDataByCategoryId(payload) || {}

    if (data?.code === 200) {
      return { data: data.data }
    }

    return { error: data?.data }
  },
  async create ({ commit, state }, payload) {
    const { data } = await api.create(payload) || {}

    if (data?.code === 200) {
      const newData = state.data
      newData.unshift(data.data)

      commit('setData', newData)

      setLocalData(PRODUCT, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data?.data }
  },
  async change ({ commit, state }, payload) {
    const { id, data: payloadData } = payload || {}
    const { data } = await api.change(id, payloadData) || {}

    if (data?.code === 200) {
      const newData = state.data.map(item => {
        if (item.id === id) {
          item = {
            ...item,
            ...payloadData
          }
        }

        return item
      })

      commit('setData', newData)

      setLocalData(PRODUCT, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  },
  async remove ({ commit, state }, productId) {
    const { data } = await api.remove(productId) || {}

    if (data?.code === 200) {
      const newData = state.data.filter(({ id }) => id !== productId )

      commit('setData', newData)

      setLocalData(PRODUCT, {
        updateDate: Date.now(),
        data: newData
      })

      return { data: data.data }
    }

    return { error: data.data }
  }
}